import { get, post, put } from "../Service/ApiConfig";
import { BannerEndPoint } from "../Service/Endpoints/ApiEndPoints";


// Create a new banner
export const createBanner = async (formData) => {
  const token = localStorage.getItem("authToken");
  
   // need to add this into a proper file with doctor form submission in future
  const response = await fetch(process.env.REACT_APP_BACKEND_URL + `api/v1/banner/add` , {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`, 
    },
  });

  return response.json();

};

//get all banners
export const getAllBanners = async () => {
  try {
    const response = await get(BannerEndPoint.getAllBanners);     
    return response;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

//Update Priority
export const UpdatePriority = async (priorityUpdates) => {
  try {
    return await put(BannerEndPoint.updatePriority, priorityUpdates);
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

//Delete
export const DeleteBanner = async (id) => {
  try {    
    return await put(BannerEndPoint.delete(id)); 
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

//get by id
export const getById = async (id) => {
  try {
    const response = await get(BannerEndPoint.getById(id));     
    return response;
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};
